export const ACTION_RESET = 'FETCH_HOMEEXHIBITOR_RESET';
export const ACTION_REQUEST = 'FETCH_HOMEEXHIBITOR_REQUEST';
export const ACTION_SUCCESS = 'FETCH_HOMEEXHIBITOR_SUCCESS';
export const ACTION_ERROR = 'FETCH_HOMEEXHIBITOR_ERROR';
